import type { SystemCompatibleResultsType } from 'features/structure/structure-slice';
import {
  DuctedFuelToken,
  systemTypeCodeFuel
} from 'utils/kept-system-type-annotation';

export type SystemCountsByCode = ReadonlyMap<string, number>;

export function buildSystemCountsByCode(
  results: SystemCompatibleResultsType | null | undefined
): SystemCountsByCode {
  const counts = new Map<string, number>();
  [results?.kept, results?.alternatives].forEach((entry) => {
    (entry?.systemTypes ?? []).forEach((systemType) => {
      counts.set(
        systemType.code,
        (counts.get(systemType.code) ?? 0) + systemType.count
      );
    });
  });
  return counts;
}

export function recommendationSystemCount(
  codes: string[],
  countsByCode: SystemCountsByCode | null | undefined,
  fuels: DuctedFuelToken[] = []
): number | null {
  if (!countsByCode) return null;
  const selectedFuels = new Set(fuels);
  const counted = codes
    .filter(
      (code) =>
        selectedFuels.size === 0 || selectedFuels.has(systemTypeCodeFuel(code))
    )
    .map((code) => countsByCode.get(code))
    .filter((count): count is number => count !== undefined);
  if (counted.length === 0) return null;
  return counted.reduce((sum, count) => sum + count, 0);
}

export function systemCountLabel(count: number): string {
  return `${count} ${count === 1 ? 'system' : 'systems'}`;
}
